import React from 'react';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withInit from 'WithInit';
import StaticBuilderDocumentPreviewTitle from 'StaticBuilder/StaticBuilderDocumentPreviewTitle';

export class StaticBuilderDocumentPreview extends React.Component {
  constructor() {
    super();

    this.hideStaticBuilderElements = this.hideStaticBuilderElements.bind(this);
    this.replaceIframeUrl = this.replaceIframeUrl.bind(this);
    this.docPreviewIframe = React.createRef();
  }

  componentDidMount() {
    this.replaceIframeUrl(`${this.props.sourceURL}&rand=${this.props.version}`);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.version !== this.props.version) {
      this.replaceIframeUrl(`${this.props.sourceURL}&rand=${this.props.version}`);
    }
    // need this check so hideStaticBuilderElements doesn't get called on
    // original variation not on mobile
    if (prevProps.isBuilderHidden !== this.props.isBuilderHidden) {
      this.hideStaticBuilderElements();
    }
  }

  hideStaticBuilderElements() {
    if (!this.props.isBuilderHidden) {
      document.querySelector('#staticBuilderContent').style.display = 'block';
      document.querySelector('.builder-toolbar-inner-wrapper').style.display = 'block';
      document.querySelector('#builderNav').style.display = 'block';
    } else {
      document.querySelector('#staticBuilderContent').style.display = 'none';
      document.querySelector('.builder-toolbar-inner-wrapper').style.display = 'none';
      document.querySelector('#builderNav').style.display = 'none';
      window.scrollTo(0, 0);
    }
  }

  replaceIframeUrl(url) {
    if (this.docPreviewIframe.contentWindow) {
      this.docPreviewIframe.contentWindow.location.replace(url);
    }
  }

  render() {
    const previewClass = classNames(
      'document-preview-redesign-wrapper',
      {
        hide: this.props.isPreviewHidden,
      },
    );

    return (
      <div className={previewClass}>
        <div className="document-preview-header">
          <StaticBuilderDocumentPreviewTitle />
        </div>
        <div id="documentPreviewBox" className="document-preview-box">
          <iframe className="document-preview" ref={(c) => { this.docPreviewIframe = c; }} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ StaticBuilderReducer }) => ({
  isPreviewHidden: StaticBuilderReducer.isPreviewHidden,
  isBuilderHidden: StaticBuilderReducer.isBuilderHidden,
  version: StaticBuilderReducer.version,
});

const StaticBuilderDocumentPreviewWithRedux = ReactRedux.connect(
  mapStateToProps,
)(StaticBuilderDocumentPreview);

StaticBuilderDocumentPreview.defaultProps = {
  isPreviewHidden: false,
  version: Math.random(),
};

StaticBuilderDocumentPreview.propTypes = {
  isBuilderHidden: PropTypes.bool.isRequired,
  isPreviewHidden: PropTypes.bool,
  sourceURL: PropTypes.string.isRequired,
  version: PropTypes.number,
};

export default withInit(StaticBuilderDocumentPreviewWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderDocumentPreview.jsx